import styled from 'styled-components'

import Theme from '@theme'

export const SamplingCampaignHintWrapper = styled.div`
  .title {
    color: ${Theme.primaryColor};
  }
`
